(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["process-steps"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(root) {
      if (!root || root.dataset.processReady) return;
      root.dataset.processReady = 'true';
      var steps = root.querySelectorAll('[data-process-step]');
      var media = root.querySelectorAll('[data-process-media]');
      function activate(index) {
        media.forEach(function (item) {
          item.classList.toggle('is-active', item.dataset.processMedia === String(index));
        });
      }
      steps.forEach(function (step) {
        step.addEventListener('toggle', function () {
          if (!step.open) return;
          steps.forEach(function (other) {
            if (other !== step && other.open) other.open = false;
          });
          activate(step.dataset.processStep);
        });
      });
    }
    function init() {
      document.querySelectorAll('[data-process-steps]').forEach(setup);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (event) {
      event.target.querySelectorAll('[data-process-steps]').forEach(setup);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wbx-shop-shelf"] && !Shopify.designMode) return;
  try {
    
(function(){
  var BANDS=[0,1000,2000,3000,4000];
  var KEY='wbxShelfBand';
  function money(c){var d=c/100;var s=(d%1===0)?d.toFixed(0):d.toFixed(2);return '$'+s.replace(/\B(?=(\d{3})+(?!\d))/g,',')}
  function lb(v){var m=String(v).replace(/,/g,'').match(/\d+/);return m?parseInt(m[0],10):-1}
  function esc(s){return String(s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})}
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  function count(el,to){
    var from=parseFloat(el.getAttribute('data-v')||'0');el.setAttribute('data-v',to);
    if(reduce||!from||from===to){el.textContent=money(to);return}
    var t0=null,dur=450;
    function step(t){if(!t0)t0=t;var k=Math.min(1,(t-t0)/dur);k=1-Math.pow(1-k,3);el.textContent=money(Math.round(from+(to-from)*k));if(k<1)requestAnimationFrame(step);else el.textContent=money(to)}
    requestAnimationFrame(step);
  }
  function init(root){
    if(!root||root.dataset.wbxInit)return;root.dataset.wbxInit='1';
    var cards=[].slice.call(root.querySelectorAll('.wbx-shelf__card'));
    var items=cards.map(function(card){
      var d={};try{d=JSON.parse(card.querySelector('.wbx-shelf__data').textContent)}catch(e){}
      var hide=(d.hide||'').toLowerCase().split(',').map(function(s){return s.trim()}).filter(Boolean);
      d.variants=(d.variants||[]).filter(function(v){var t=v.t.toLowerCase();return !hide.some(function(h){return t.indexOf(h)>-1})});
      d.sized=-1;(d.options||[]).forEach(function(n,i){if(/size|square|home/i.test(n)&&d.variants.some(function(v){return /sq/i.test(v.o[i])}))if(d.sized<0)d.sized=i});
      d.min=d.variants.reduce(function(m,v){return Math.min(m,v.p)},Infinity);d.multi=(d.options||[]).some(function(n,i){if(i===d.sized)return false;var u={};d.variants.forEach(function(v){u[v.o[i]]=1});return Object.keys(u).length>1});
      return {card:card,d:d,price:card.querySelector('.wbx-shelf__price b'),pre:card.querySelector('.wbx-shelf__pre')};
    });
    /* tabs */
    var help=root.querySelector('.wbx-shelf__help'),cur_n=0;
    function cols(){return innerWidth>=1200?4:(innerWidth>=750?3:1)}
    function place(){if(!help)return;var c=cols();
      var slots=cur_n;if(c>1&&root.classList.contains('has-leads'))items.forEach(function(it){if(!it.card.hidden&&it.card.classList.contains('is-lead'))slots++});
      var r=slots%c,span=r?c-r:c;help.hidden=false;help.style.setProperty('--span',span);help.classList.toggle('is-wide',span>=3);help.classList.toggle('is-one',span===1&&c>1);
      var under=c===1&&root.classList.contains('has-swipe');if(under){if(help.previousElementSibling!==rail)rail.parentNode.insertBefore(help,rail.nextSibling)}else if(help.parentNode!==rail)rail.appendChild(help);if(span&&help.parentNode){if(!under)help.parentNode.appendChild(help);if(!reduce){help.classList.remove('is-in');void help.offsetWidth;help.style.animationDelay=(cur_n*55)+'ms';help.classList.add('is-in')}}}
    var rt;window.addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(place,120)});
    var tabs=[].slice.call(root.querySelectorAll('.wbx-shelf__tab'));
    var rail=root.querySelector('.wbx-shelf__rail'),countEl=root.querySelector('.wbx-shelf__count');
    var catNow='all',sortNow='rec';
    var catLabel={};tabs.forEach(function(t){catLabel[t.getAttribute('data-cat')]=t.firstChild.textContent.trim()});
    function flip(fn){
      var vis=items.filter(function(it){return !it.card.hidden});
      var before=new Map();vis.forEach(function(it){before.set(it.card,it.card.getBoundingClientRect())});
      fn();
      if(reduce)return;
      items.forEach(function(it){var b=before.get(it.card);if(!b||it.card.hidden)return;var a=it.card.getBoundingClientRect();var dx=b.left-a.left,dy=b.top-a.top;if(!dx&&!dy)return;
        it.card.classList.remove('is-moving');it.card.style.transform='translate('+dx+'px,'+dy+'px)';
        requestAnimationFrame(function(){requestAnimationFrame(function(){it.card.classList.add('is-moving');it.card.style.transform='';})});
        setTimeout(function(){it.card.classList.remove('is-moving')},520)});
    }
    function priceOf(it){var v=parseFloat(it.price.getAttribute('data-v'));return isNaN(v)?it.d.min:v}
    function order(){
      var list=items.slice();
      if(sortNow==='rec')list.sort(function(a,b){return a.card.getAttribute('data-i')-b.card.getAttribute('data-i')});
      else list.sort(function(a,b){return sortNow==='asc'?priceOf(a)-priceOf(b):priceOf(b)-priceOf(a)});
      list.forEach(function(it){rail.appendChild(it.card)});
    }
    function apply(anim){
      var run=function(){
        var n=0;items.forEach(function(it){var on=catNow==='all'||it.card.getAttribute('data-cat')===catNow;it.card.hidden=!on;if(on)n++});
        order();cur_n=n;place();
        if(countEl)countEl.innerHTML='Showing <b>'+n+'</b> '+(n===1?'service':'services')+(catNow==='all'?'':' in '+esc(catLabel[catNow]||''))+(sortNow==='rec'?'':' · '+(sortNow==='asc'?'lowest':'highest')+' price first');
      };
      if(anim)flip(run);else run();
    }
    tabs.forEach(function(t){t.addEventListener('click',function(){
      var c=t.getAttribute('data-cat');catNow=(catNow===c&&c!=='all')?'all':c;
      tabs.forEach(function(x){x.setAttribute('aria-pressed',String(x.getAttribute('data-cat')===catNow))});
      var entering=items.filter(function(it){return it.card.hidden&&(catNow==='all'||it.card.getAttribute('data-cat')===catNow)});
      apply(true);
      if(!reduce)entering.forEach(function(it,k){it.card.classList.remove('is-in');void it.card.offsetWidth;it.card.style.animationDelay=(k*40)+'ms';it.card.classList.add('is-in')});
    })});
    [].slice.call(root.querySelectorAll('.wbx-shelf__pick[data-pick]')).forEach(function(b){b.addEventListener('click',function(){
      var t=root.querySelector('.wbx-shelf__tab[data-cat="'+b.getAttribute('data-pick')+'"]');if(!t)return;
      if(t.getAttribute('aria-pressed')!=='true')t.click();
      var bar=root.querySelector('.wbx-shelf__tabs');if(bar)bar.scrollIntoView({behavior:reduce?'auto':'smooth',block:'center'});
    })});
    /* a link to #shop-<tab key> (the pest router's Book online) opens that tab here; with data-look="<product handle>"
       it opens that product's quick look in place instead, so the visitor never leaves the card they were reading */
    function lookItem(a){var h=a.getAttribute('data-look');if(!h)return null;
      return items.filter(function(it){return it.card.querySelector('button.wbx-shelf__look')&&String(it.d.url||'').split('?')[0].replace(/\/$/,'').split('/').pop()===h})[0]||null}
    function openTab(h){var m=/^#shop-([a-z0-9_-]+)$/i.exec(h||'');if(!m)return false;var t=root.querySelector('.wbx-shelf__tab[data-cat="'+m[1]+'"]');if(!t)return false;
      if(t.getAttribute('aria-pressed')!=='true')t.click();var bar=root.querySelector('.wbx-shelf__tabs')||root;bar.scrollIntoView({behavior:reduce?'auto':'smooth',block:'center'});return true}
    document.addEventListener('click',function(e){var a=e.target.closest&&e.target.closest('a[href^="#shop-"]');if(!a)return;var li=lookItem(a);if(li){e.preventDefault();open(li,a);return}if(openTab(a.getAttribute('href'))){e.preventDefault();try{history.replaceState(null,'',a.getAttribute('href'))}catch(err){}}});
    if(/^#shop-/.test(location.hash))setTimeout(function(){openTab(location.hash)},300);
    var sorts=[].slice.call(root.querySelectorAll('.wbx-shelf__sortbtn'));
    sorts.forEach(function(b){b.addEventListener('click',function(){sortNow=b.getAttribute('data-sort');sorts.forEach(function(x){x.setAttribute('aria-pressed',String(x===b))});apply(true)})});
    /* home size */
    var band=null;try{var s=sessionStorage.getItem(KEY);if(s!==null&&s!=='')band=parseInt(s,10)}catch(e){}
    var chips=[].slice.call(root.querySelectorAll('.wbx-shelf__chip'));
    var hint=root.querySelector('.wbx-shelf__hint');
    function priceFor(d,b){
      if(d.sized<0||b===null)return null;
      var c=d.variants.filter(function(v){return lb(v.o[d.sized])===b&&v.a!==false});
      if(!c.length)return null;
      return c.reduce(function(m,v){return Math.min(m,v.p)},Infinity);
    }
    function applyBand(){
      chips.forEach(function(c){c.setAttribute('aria-pressed',String(band!==null&&parseInt(c.getAttribute('data-band'),10)===band))});
      if(hint){var on=chips.filter(function(c){return c.getAttribute('aria-pressed')==='true'})[0];hint.innerHTML=on?'Prices shown for <b>'+esc(on.textContent.trim())+'</b>':hint.getAttribute('data-default')}
      items.forEach(function(it){
        var p=priceFor(it.d,band);
        if(p!==null&&p!==Infinity){count(it.price,p);if(it.pre){it.pre.textContent=it.d.multi?'yours from':'your price';it.pre.classList.add('is-yours')}}
        else if(it.d.min!==Infinity){count(it.price,it.d.min);if(it.pre){it.pre.textContent=it.pre.getAttribute('data-default');it.pre.classList.remove('is-yours')}}
      });
    }
    chips.forEach(function(c){c.addEventListener('click',function(){var b=parseInt(c.getAttribute('data-band'),10);band=(band===b)?null:b;try{sessionStorage.setItem(KEY,band===null?'':String(band))}catch(e){}applyBand();if(sortNow!=='rec')setTimeout(function(){apply(true)},480)})});
    items.forEach(function(it){if(it.d.min!==Infinity)it.price.setAttribute('data-v',it.d.min)});
    if(hint&&!hint.getAttribute('data-default'))hint.setAttribute('data-default',hint.innerHTML);
    applyBand();apply(false);
    /* quick look */
    var panel=root.querySelector('.wbx-shelf__panel'),scrim=root.querySelector('.wbx-shelf__scrim');
    if(!panel)return;
    document.body.appendChild(scrim);document.body.appendChild(panel);
    var lastBtn=null,cur=null,sel=[],plan=null;
    function variant(){if(!cur)return null;var d=cur.d;return d.variants.filter(function(v){return v.o.every(function(x,i){return x===sel[i]})})[0]||null}
    function render(){
      var d=cur.d,v=variant();
      var groups='';
      (d.options||[]).forEach(function(name,i){
        var vals=[];d.variants.forEach(function(x){if(vals.indexOf(x.o[i])<0)vals.push(x.o[i])});
        if(vals.length<2&&/^title$/i.test(name))return;
        if(vals.length<2&&!/frequency|size/i.test(name))return;
        groups+='<fieldset class="wbx-shelf__group"><legend>'+esc(name.replace(/:$/,''))+'</legend><div class="wbx-shelf__opts">'+vals.map(function(val){
          var ok=d.variants.some(function(x){return x.o[i]===val&&x.o.every(function(y,k){return k===i||y===sel[k]})});
          return '<button type="button" class="wbx-shelf__opt" data-i="'+i+'" data-v="'+esc(val)+'" aria-pressed="'+(sel[i]===val)+'"'+(ok?'':' disabled')+'>'+esc(val)+'</button>'}).join('')+'</div></fieldset>';
      });
      if(d.plans&&d.plans.length){
        groups+='<fieldset class="wbx-shelf__group"><legend>How often</legend><div class="wbx-shelf__opts"><button type="button" class="wbx-shelf__opt" data-plan="" aria-pressed="'+(!plan)+'">One time</button>'+d.plans.map(function(p){return '<button type="button" class="wbx-shelf__opt" data-plan="'+p.id+'" aria-pressed="'+(String(plan)===String(p.id))+'">'+esc(p.name)+(p.adj?' · save '+p.adj+'%':'')+'</button>'}).join('')+'</div></fieldset>';
      }
      panel.querySelector('.wbx-shelf__p-groups').innerHTML=groups;
      var price=v?v.p:d.min,was='';
      var pl=(d.plans||[]).filter(function(p){return String(p.id)===String(plan)})[0];
      if(pl&&pl.adj){was='<s>'+money(price)+'</s>';price=Math.round(price*(100-pl.adj)/100)}
      panel.querySelector('.wbx-shelf__p-price').innerHTML='<span>'+(v?(d.sized>-1&&band!==null&&lb(v.o[d.sized])===band?'Your price':'Price'):'From')+(pl?' · '+esc(pl.name.toLowerCase()):'')+'</span><b>'+was+money(price)+'</b>';
      var href=d.url+(v?'?variant='+v.id:'')+(pl?(v?'&':'?')+'selling_plan='+pl.id:'');
      var addB=panel.querySelector('.wbx-shelf__add'),nowB=panel.querySelector('.wbx-shelf__now');
      var ok=!!v&&v.a!==false;addB.disabled=!ok;nowB.disabled=!ok;addB.classList.remove('is-added');addB.querySelector('span').textContent=addLabel;
      panel.querySelector('.wbx-shelf__err').hidden=true;
      panel.querySelector('.wbx-shelf__more').href=d.url;
    }
    var addLabel=(panel.querySelector('.wbx-shelf__add span')||{}).textContent||'Add to cart';
    var pill=root.querySelector('.wbx-shelf__cartpill');
    function setPill(n){if(!pill)return;pill.hidden=!n;pill.querySelector('.wbx-shelf__cartn').textContent=n+(n===1?' item in cart':' items in cart')}
    fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json()}).then(function(c){setPill(c.item_count)}).catch(function(){});
    var toastEl=null,toastT=null;
    function toast(title,img,sub){
      if(!toastEl){toastEl=document.createElement('div');toastEl.className='wbx-shelf__toast';toastEl.setAttribute('role','status');toastEl.setAttribute('aria-live','polite');document.body.appendChild(toastEl)}
      toastEl.innerHTML=(img?'<img src="'+esc(img+(img.indexOf('?')>-1?'&':'?')+'width=96')+'" alt="" width="48" height="48">':'')+'<div class="wbx-shelf__toast-t"><span>✓ Added to your cart</span><b>'+esc(title)+'</b>'+(sub?'<i>'+esc(sub)+'</i>':'')+'</div><a class="wbx-shelf__toast-v" href="/cart">View cart</a><a class="wbx-shelf__toast-c" href="/checkout">Checkout</a><button type="button" aria-label="Dismiss">×</button>';
      toastEl.querySelector('button').onclick=function(){toastEl.classList.remove('is-on')};
      void toastEl.offsetWidth;toastEl.classList.add('is-on');clearTimeout(toastT);toastT=setTimeout(function(){toastEl.classList.remove('is-on')},7000);
    }
    var visitWrap=panel.querySelector('.wbx-shelf__visit'),visitApi=null,savedBox=panel.querySelector('.wbx-shelf__saved'),vbtns=panel.querySelector('.wbx-shelf__vbtns'),pendingGo=null;
    function visitEnsure(){if(!visitApi&&window.WbxVisit)visitApi=WbxVisit.bind(visitWrap.querySelector('[data-wbx-visit]'));return visitApi}
    function renderSaved(){if(savedBox)savedBox.innerHTML=''}
    function showVisit(go){
      if(!visitEnsure())return;pendingGo=go;var v=WbxVisit.get();if(v)visitApi.fill(v);WbxVisit.loadZips();
      panel.classList.add('is-visit');visitWrap.hidden=false;vbtns.hidden=false;
      vbtns.querySelector('.wbx-shelf__vgo span').textContent=go===true?'Continue to checkout':(go===false?'Add to cart':'Save details');
      panel.querySelector('.wbx-shelf__p-scroll').scrollTop=0;
      setTimeout(function(){var f=visitWrap.querySelector('[data-part=street]');if(f&&!f.value)f.focus({preventScroll:true})},80);
    }
    function hideVisit(){panel.classList.remove('is-visit');vbtns.hidden=true;pendingGo=null;renderSaved();if(visitEnsure()){var sv=WbxVisit.get();if(sv)visitApi.fill(sv);visitWrap.hidden=false;WbxVisit.loadZips()}}
    savedBox.addEventListener('click',function(e){if(e.target.closest('[data-wbx-edit]'))showVisit(null)});
    vbtns.querySelector('.wbx-shelf__vback').addEventListener('click',hideVisit);
    vbtns.querySelector('.wbx-shelf__vgo').addEventListener('click',function(){
      visitApi.validate();WbxVisit.set(visitApi.values());var go=pendingGo,props=visitApi.props();if(!Object.keys(props).length)props=null;
      if(go===null){hideVisit();return}
      hideVisit();doAdd(go,props);
    });
    function propsFromStored(){var p=WbxVisit.propsOf(WbxVisit.get());return Object.keys(p).length?p:null}
    function addToCart(go){
      if(!variant())return;
      if(!window.WbxVisit){doAdd(go,null);return}
      if(visitEnsure()){visitApi.validate();WbxVisit.set(visitApi.values());var p=visitApi.props();doAdd(go,Object.keys(p).length?p:null)}else doAdd(go,propsFromStored());
    }
    function doAdd(go,props){
      var v=variant();if(!v)return;
      var tLabel=cur.d.title+(v.t&&!/^default title$/i.test(v.t)?' · '+v.t:''),tImg=cur.d.image||'';
      var addB=panel.querySelector('.wbx-shelf__add'),nowB=panel.querySelector('.wbx-shelf__now'),err=panel.querySelector('.wbx-shelf__err');
      var notif=document.querySelector('cart-notification');
      var item={id:v.id,quantity:1};if(plan)item.selling_plan=+plan;if(props)item.properties=props;
      var body={items:[item]};
      if(!go&&document.getElementById('cart-icon-bubble')){body.sections='cart-icon-bubble';body.sections_url=location.pathname}
      addB.disabled=nowB.disabled=true;err.hidden=true;if(!go)addB.querySelector('span').textContent='Adding…';
      fetch((window.routes&&window.routes.cart_add_url?window.routes.cart_add_url:'/cart/add')+'.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)})
      .then(function(r){return r.json().then(function(j){return{ok:r.ok,j:j}})})
      .then(function(res){
        if(!res.ok){throw new Error(res.j.description||res.j.message||'Could not add this item.')}
        if(go){location.href='/checkout';return}
        addB.classList.add('is-added');addB.querySelector('span').textContent='Added ✓';
        fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json()}).then(function(c){setPill(c.item_count)}).catch(function(){});
        setTimeout(function(){
          close(true);
          var b=document.getElementById('cart-icon-bubble');
          if(b&&res.j.sections&&res.j.sections['cart-icon-bubble']){try{var dd=new DOMParser().parseFromString(res.j.sections['cart-icon-bubble'],'text/html');var src=dd.querySelector('.shopify-section')||dd.body;b.innerHTML=src.innerHTML}catch(e){}}
          toast(tLabel,tImg,props?'We’ll call or text to confirm your visit, usually within 15 minutes during business hours.':'');
        },650);
      })
      .catch(function(e){err.textContent=e.message;err.hidden=false;addB.disabled=nowB.disabled=false;addB.querySelector('span').textContent=addLabel});
    }
    panel.querySelector('.wbx-shelf__add').addEventListener('click',function(){addToCart(false)});
    panel.querySelector('.wbx-shelf__now').addEventListener('click',function(){addToCart(true)});
    function open(it,btn){
      cur=it;lastBtn=btn;plan=null;var d=it.d;
      var first=d.variants.slice().sort(function(a,b){return a.p-b.p})[0]||{o:[]};
      sel=first.o.slice();
      if(d.sized>-1&&band!==null){var m=d.variants.filter(function(v){return lb(v.o[d.sized])===band}).sort(function(a,b){return a.p-b.p})[0];if(m)sel=m.o.slice()}
      var img=panel.querySelector('.wbx-shelf__p-media img');
      if(d.image){img.src=d.image;img.alt=d.title;img.hidden=false}else img.hidden=true;
      panel.querySelector('.wbx-shelf__kind').textContent=d.kind||'';
      panel.querySelector('.wbx-shelf__p-title').textContent=d.title;
      panel.querySelector('.wbx-shelf__p-desc').textContent=d.desc||'';
      var note=panel.querySelector('.wbx-shelf__note');note.textContent=d.note||'';note.hidden=!d.note;
      render();hideVisit();
      root.classList.add('is-open');document.documentElement.classList.add('wbx-shelf-lock');
      panel.classList.add('is-on');scrim.classList.add('is-on');
      panel.setAttribute('aria-hidden','false');panel.querySelector('.wbx-shelf__p-scroll').scrollTop=0;
      setTimeout(function(){panel.querySelector('.wbx-shelf__x').focus()},60);
    }
    function close(quiet){
      if(!cur)return;cur=null;
      root.classList.remove('is-open');document.documentElement.classList.remove('wbx-shelf-lock');
      panel.classList.remove('is-on');scrim.classList.remove('is-on');panel.setAttribute('aria-hidden','true');
      if(lastBtn&&quiet!==true)lastBtn.focus();
    }
    items.forEach(function(it){var b=it.card.querySelector('button.wbx-shelf__look');if(b)b.addEventListener('click',function(){open(it,b)})});
    panel.addEventListener('click',function(e){
      var o=e.target.closest('.wbx-shelf__opt');
      if(o&&!o.disabled){
        if(o.hasAttribute('data-plan')){plan=o.getAttribute('data-plan')||null}
        else{var i=+o.getAttribute('data-i');sel[i]=o.getAttribute('data-v');
          if(!variant()){var d=cur.d;var m=d.variants.filter(function(v){return v.o[i]===sel[i]}).sort(function(a,b){return a.p-b.p})[0];if(m)sel=m.o.slice()}}
        render();return;
      }
      if(e.target.closest('.wbx-shelf__x'))close();
    });
    scrim.addEventListener('click',close);
    document.addEventListener('keydown',function(e){
      if(!cur)return;
      if(e.key==='Escape'){close();return}
      if(e.key==='Tab'){var f=[].slice.call(panel.querySelectorAll('a[href],button:not([disabled])')).filter(function(x){return x.offsetParent!==null});if(!f.length)return;var a=f[0],z=f[f.length-1];if(e.shiftKey&&document.activeElement===a){e.preventDefault();z.focus()}else if(!e.shiftKey&&document.activeElement===z){e.preventDefault();a.focus()}}
    });
    var y0=null;
    panel.addEventListener('touchstart',function(e){var sc=panel.querySelector('.wbx-shelf__p-scroll');y0=(sc.scrollTop<=0)?e.touches[0].clientY:null},{passive:true});
    panel.addEventListener('touchmove',function(e){if(y0===null)return;var dy=e.touches[0].clientY-y0;if(dy>0)panel.style.transform='translateY('+dy+'px)'},{passive:true});
    panel.addEventListener('touchend',function(e){if(y0===null)return;var dy=(e.changedTouches[0].clientY-y0);panel.style.transform='';y0=null;if(dy>90)close()});
  }
  function all(){[].forEach.call(document.querySelectorAll('.wbx-shelf'),init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all);else all();
  document.addEventListener('shopify:section:load',function(e){var r=e.target.querySelector('.wbx-shelf');if(r){[].forEach.call(document.querySelectorAll('body>.wbx-shelf__panel,body>.wbx-shelf__scrim'),function(n){n.remove()});init(r)}});
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wbx-shop"] && !Shopify.designMode) return;
  try {
    
(function(){
  var KEY='wbxShelfBand';
  function money(c){var d=c/100;var s=(d%1===0)?d.toFixed(0):d.toFixed(2);return '$'+s.replace(/\B(?=(\d{3})+(?!\d))/g,',')}
  function fmt(n){return String(n).replace(/\B(?=(\d{3})+(?!\d))/g,',')}
  function lb(v){var m=String(v).replace(/,/g,'').match(/\d+/);return m?parseInt(m[0],10):-1}
  function inBand(v,b){var l=lb(v);return b===4000?l>=4000:l===b}
  function esc(s){return String(s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})}
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  function count(el,to){
    var from=parseFloat(el.getAttribute('data-v')||'0');el.setAttribute('data-v',to);
    if(reduce||!from||from===to){el.textContent=money(to);return}
    var t0=null,dur=420;
    function step(t){if(!t0)t0=t;var k=Math.min(1,(t-t0)/dur);k=1-Math.pow(1-k,3);el.textContent=money(Math.round(from+(to-from)*k));if(k<1)requestAnimationFrame(step);else el.textContent=money(to)}
    requestAnimationFrame(step);
  }
  /* readable option labels */
  function prettyVal(name,val,vals){
    var s=String(val).trim(),n=String(name||'').toLowerCase(),c=s.replace(/,/g,'');
    var anySq=vals.some(function(v){return /sq/i.test(v)}),anyLin=/linear/i.test(n)||vals.some(function(v){return /linear/i.test(v)});
    if(/^\$\s*\d/.test(s))return s.replace(/\.00$/,'');
    var r=c.match(/^(\d+)\s*[-–]\s*(\d+)(\+?)/),one=c.match(/^(\d+)(\+?)\s*(sq|linear)?/i);
    if(anySq){
      if(r){var a=+r[1],b=+r[2];if(a===0)return 'Under '+fmt(b+1)+' sq ft';return fmt(a)+'–'+fmt(b)+(r[3]||'')+' sq ft'}
      if(one){var x=+one[1];return (x>=4000||one[2])?fmt(x)+'+ sq ft':fmt(x)+' sq ft'}
    }
    if(anyLin){
      if(r)return fmt(+r[1])+'–'+fmt(+r[2])+(r[3]||'')+' ft';
      if(one)return fmt(+one[1])+'+ ft';
    }
    if(/^\d+$/.test(c)){var k=+c;return k+(k===1?' station':' stations')}
    if(/story/i.test(s))return s.replace(/\s*structure/i,'').replace(/(\d)\s*story/i,'$1-story');
    return s;
  }
  function prettyLegend(name,vals){
    var n=String(name||'').toLowerCase().replace(/:$/,'');
    if(vals.some(function(v){return /sq/i.test(v)}))return 'Home size';
    if(vals.some(function(v){return /linear/i.test(v)}))return 'Feet around your home';
    if(/linear/.test(n))return 'Linear feet of wood treated';
    if(/amount/.test(n))return 'How many stations';
    if(/type/.test(n))return 'Property type';
    if(/denomination/.test(n))return 'Amount';
    if(/frequency/.test(n))return 'How often';
    if(/size/.test(n)&&vals.some(function(v){return /story/i.test(v)}))return 'Stories';
    return name.replace(/:$/,'');
  }
  function init(root){
    if(!root||root.dataset.wbxInit)return;root.dataset.wbxInit='1';
    /* sticky offset: the call bar above the header is sticky too */
    function offset(){var h=0;[].forEach.call(document.querySelectorAll('.call-bar-section,.section-header'),function(el){var st=getComputedStyle(el);if((st.position==='sticky'||st.position==='fixed')&&st.top!=='auto')h=Math.max(h,el.getBoundingClientRect().height)});root.style.setProperty('--wbx-shop-top',Math.round(h)+'px')}
    offset();window.addEventListener('resize',offset);
    /* items */
    var cards=[].slice.call(root.querySelectorAll('.wbx-shop__card'));
    var items=cards.map(function(card){
      var d={};try{d=JSON.parse(card.querySelector('.wbx-shop__data').textContent)}catch(e){}
      var hide=(d.hide||'').toLowerCase().split(',').map(function(s){return s.trim()}).filter(Boolean);
      d.variants=(d.variants||[]).filter(function(v){var t=v.t.toLowerCase();return !hide.some(function(h){return t.indexOf(h)>-1})});
      d.sized=-1;(d.options||[]).forEach(function(n,i){if(/size|square|home/i.test(n)&&d.variants.some(function(v){return /sq/i.test(v.o[i])}))if(d.sized<0)d.sized=i});
      d.min=d.variants.reduce(function(m,v){return Math.min(m,v.p)},Infinity);
      var it={card:card,d:d,sel:[],plan:null,price:card.querySelector('.wbx-shop__price b'),pre:card.querySelector('.wbx-shop__pre'),was:card.querySelector('.wbx-shop__was'),add:card.querySelector('.wbx-shop__add'),unit:card.querySelector('.wbx-shop__unit'),err:card.querySelector('.wbx-shop__err'),groups:[]};
      it.addLabel=it.add.querySelector('span').textContent;
      [].forEach.call(card.querySelectorAll('.wbx-shop__group[data-i]'),function(g){
        var i=+g.getAttribute('data-i'),tiles=[].slice.call(g.querySelectorAll('.wbx-shop__tile')),vals=tiles.map(function(t){return t.getAttribute('data-v')});
        var leg=g.querySelector('legend');if(leg)leg.textContent=prettyLegend(leg.getAttribute('data-name')||leg.textContent,vals);
        tiles.forEach(function(t){t.textContent=prettyVal(d.options[i],t.getAttribute('data-v'),vals)});
        it.groups.push({i:i,tiles:tiles});
      });
      it.planTiles=[].slice.call(card.querySelectorAll('.wbx-shop__tile[data-plan]'));
      var first=d.variants.slice().sort(function(a,b){return a.p-b.p})[0]||{o:[]};it.sel=first.o.slice();
      if(d.min!==Infinity)it.price.setAttribute('data-v',d.min);
      return it;
    });
    function variant(it){return it.d.variants.filter(function(v){return v.o.every(function(x,i){return x===it.sel[i]})})[0]||null}
    function render(it){
      var d=it.d,v=variant(it);
      it.groups.forEach(function(g){g.tiles.forEach(function(t){var val=t.getAttribute('data-v');
        var ok=d.variants.some(function(x){return x.o[g.i]===val&&x.o.every(function(y,k){return k===g.i||y===it.sel[k]})});
        t.setAttribute('aria-pressed',String(it.sel[g.i]===val));t.disabled=!ok})});
      it.planTiles.forEach(function(t){t.setAttribute('aria-pressed',String((t.getAttribute('data-plan')||null)===it.plan))});
      var price=v?v.p:d.min,pl=(d.plans||[]).filter(function(p){return String(p.id)===String(it.plan)})[0];
      if(pl&&pl.adj){it.was.textContent=money(price);it.was.hidden=false;price=Math.round(price*(100-pl.adj)/100)}else{it.was.hidden=true}
      count(it.price,price);
      [].forEach.call(it.card.querySelectorAll('[data-gc]'),function(li){li.classList.toggle('is-on',!!v&&li.getAttribute('data-gc')===v.t)});
      var yours=d.sized>-1&&band!==null&&v&&inBand(v.o[d.sized],band);
      it.pre.textContent=yours?'Your price':(pl?pl.name:'');it.pre.classList.toggle('is-yours',!!yours);
      it.add.disabled=!(v&&v.a!==false);it.err.hidden=true;
      if(it.unit&&d.then){var list=String(d.then).split(',').map(function(x){return x.trim()}),idx=[0,1000,2000,3000,4000].indexOf(band);
        if(d.sized>-1&&band!==null&&idx>-1&&v){var tv=d.then==='same'?money(v.p):(/^\d/.test(list[idx]||'')?'$'+list[idx]:null);it.unit.textContent=tv?'to start, then '+tv+' '+(d.thenUnit||''):(list[idx]?'to start, '+list[idx]:d.unit)}else it.unit.textContent=d.unit}
    }
    /* Kevin's ticket follows the size bar: that size's start-up price, halved */
    var kvs=[].slice.call(root.querySelectorAll('[data-kv]')).map(function(el){var j={};try{j=JSON.parse(el.querySelector('.wbx-shop__kv-data').textContent)}catch(e){}var l=el.querySelector('[data-kv-lbl]');return{j:j,lbl:l,def:l?l.textContent:'',was:el.querySelector('[data-kv-was]'),now:el.querySelector('[data-kv-now]')}});
    function kvBand(){kvs.forEach(function(k){if(!k.j.v||!k.lbl||!k.j.v.length)return;var vs=k.j.v.slice().sort(function(a,b){return a.p-b.p}),v=band===null?vs[0]:(vs.filter(function(x){return inBand(x.t,band)})[0]||vs[0]);var on=chips.filter(function(c){return c.getAttribute('aria-pressed')==='true'})[0];
      k.lbl.textContent=(band!==null&&on&&k.j.label)?k.j.label.replace('{size}',on.textContent.trim().replace(/^Under/,'under')+' sq ft'):k.def;k.was.textContent=money(v.p);k.now.textContent=money(Math.round(v.p/2))})}
    [].forEach.call(root.querySelectorAll('[data-kv-copy]'),function(b){var label=b.textContent;b.addEventListener('click',function(){var code=b.getAttribute('data-kv-copy');
      try{fetch('/discount/'+encodeURIComponent(code),{credentials:'same-origin'})}catch(e){}
      var ok=function(){b.textContent=b.getAttribute('data-done')||label;setTimeout(function(){b.textContent=label},2400)};
      try{navigator.clipboard.writeText(code).then(ok,ok)}catch(e){ok()}})});
    /* band */
    var band=null;try{var s=sessionStorage.getItem(KEY);if(s!==null&&s!=='')band=parseInt(s,10)}catch(e){}
    var chips=[].slice.call(root.querySelectorAll('.wbx-shop__chip')),hint=root.querySelector('.wbx-shop__hint');
    if(hint&&!hint.getAttribute('data-default'))hint.setAttribute('data-default',hint.innerHTML);
    function applyBand(){
      chips.forEach(function(c){c.setAttribute('aria-pressed',String(band!==null&&parseInt(c.getAttribute('data-band'),10)===band))});
      if(hint){var on=chips.filter(function(c){return c.getAttribute('aria-pressed')==='true'})[0];hint.innerHTML=on?'Prices shown for <b>'+esc(on.textContent.trim())+' sq ft</b>':hint.getAttribute('data-default')}
      kvBand();
      items.forEach(function(it){var d=it.d;if(d.sized<0||band===null){render(it);return}
        var keep=d.variants.filter(function(v){return inBand(v.o[d.sized],band)&&v.o[d.sized]===it.sel[d.sized]&&v.o.every(function(x,k){return k===d.sized||x===it.sel[k]})})[0];
        var m=keep||d.variants.filter(function(v){return inBand(v.o[d.sized],band)}).sort(function(a,b){return a.p-b.p})[0];
        if(m)it.sel=m.o.slice();render(it)});
    }
    function setBand(b){band=b;try{sessionStorage.setItem(KEY,band===null?'':String(band))}catch(e){}applyBand()}
    chips.forEach(function(c){c.addEventListener('click',function(){var b=parseInt(c.getAttribute('data-band'),10);setBand(band===b?null:b)})});
    /* tiles */
    items.forEach(function(it){
      it.card.addEventListener('click',function(e){
        var t=e.target.closest('.wbx-shop__tile');if(!t||t.disabled)return;
        if(t.hasAttribute('data-plan')){it.plan=t.getAttribute('data-plan')||null;render(it);return}
        var g=t.closest('.wbx-shop__group'),i=+g.getAttribute('data-i'),val=t.getAttribute('data-v');
        if(i===it.d.sized){var b=lb(val);b=b>=4000?4000:b;if(b>=0&&b!==band){it.sel[i]=val;setBand(b);return}}
        it.sel[i]=val;
        if(!variant(it)){var m=it.d.variants.filter(function(v){return v.o[i]===val}).sort(function(a,b){return a.p-b.p})[0];if(m)it.sel=m.o.slice()}
        render(it);
      });
    });
    /* cart bar */
    var bar=root.querySelector('.wbx-shop__cartbar'),barN=bar.querySelector('.wbx-shop__cart-n'),barT=bar.querySelector('.wbx-shop__cart-total');
    function setBar(c){if(!bar)return;var n=c.item_count||0;if(!n){bar.classList.remove('is-on');setTimeout(function(){if(!bar.classList.contains('is-on'))bar.hidden=true},400);return}
      barN.innerHTML=n+'<span>'+(n===1?' service':' services')+'</span> in your cart';barT.textContent=money(c.total_price||0)+' so far';bar.hidden=false;void bar.offsetWidth;bar.classList.add('is-on')}
    function refreshBar(){fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json()}).then(setBar).catch(function(){})}
    refreshBar();
    function props(){if(!window.WbxVisit)return null;var p=WbxVisit.propsOf(WbxVisit.get());return Object.keys(p).length?p:null}
    function add(it,ext){
      var xs=ext?ext.querySelector('span'):null,xl=xs?xs.textContent:'';function lab(t){if(xs)xs.textContent=t===null?xl:t}
      var v=variant(it);if(!v)return;
      var item={id:v.id,quantity:1};if(it.plan)item.selling_plan=+it.plan;var pr=props();if(pr&&!it.d.gift)item.properties=pr;
      var body={items:[item]};if(document.getElementById('cart-icon-bubble')){body.sections='cart-icon-bubble';body.sections_url=location.pathname}
      it.add.disabled=true;it.err.hidden=true;it.add.querySelector('span').textContent='Adding…';lab('Adding…');
      fetch((window.routes&&window.routes.cart_add_url?window.routes.cart_add_url:'/cart/add')+'.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)})
      .then(function(r){return r.json().then(function(j){return{ok:r.ok,j:j}})})
      .then(function(res){
        if(!res.ok)throw new Error(res.j.description||res.j.message||'Could not add this item.');
        it.add.classList.add('is-added');it.add.querySelector('span').textContent='Added ✓';it.add.disabled=false;lab('Added ✓');
        var b=document.getElementById('cart-icon-bubble');
        if(b&&res.j.sections&&res.j.sections['cart-icon-bubble']){try{var dd=new DOMParser().parseFromString(res.j.sections['cart-icon-bubble'],'text/html');var src=dd.querySelector('.shopify-section')||dd.body;b.innerHTML=src.innerHTML}catch(e){}}
        refreshBar();
        setTimeout(function(){it.add.classList.remove('is-added');it.add.querySelector('span').textContent=it.addLabel;lab(null)},2200);
      })
      .catch(function(e){it.err.textContent=e.message;it.err.hidden=false;it.add.disabled=false;it.add.querySelector('span').textContent=it.addLabel;lab(null)});
    }
    items.forEach(function(it){it.add.addEventListener('click',function(){add(it)})});
    /* a ticket button adds its product through that card */
    [].forEach.call(root.querySelectorAll('[data-add]'),function(b){b.addEventListener('click',function(){var it=items.filter(function(x){return x.card.getAttribute('data-handle')===b.getAttribute('data-add')})[0];if(it)add(it,b)})});
    /* jump chips follow the band in view */
    var jumps=[].slice.call(root.querySelectorAll('.wbx-shop__jumpchip')),bands=[].slice.call(root.querySelectorAll('[data-band-anchor]'));
    function mark(id){jumps.forEach(function(j){var on=j.getAttribute('href')==='#'+id;if(on)j.setAttribute('aria-current','true');else j.removeAttribute('aria-current')})}
    if('IntersectionObserver' in window&&bands.length){
      var vis={};var io=new IntersectionObserver(function(es){es.forEach(function(e){vis[e.target.id]=e.isIntersecting?e.intersectionRatio:0});
        var best=null,bv=0;bands.forEach(function(b){if((vis[b.id]||0)>bv){bv=vis[b.id];best=b.id}});if(best)mark(best)},{rootMargin:'-35% 0px -45% 0px',threshold:[0,.1,.25,.5,.75,1]});
      bands.forEach(function(b){io.observe(b)});
    }
    jumps.forEach(function(j){j.addEventListener('click',function(e){var id=j.getAttribute('href').slice(1),el=document.getElementById(id);if(!el)return;e.preventDefault();el.scrollIntoView({behavior:reduce?'auto':'smooth',block:'start'});mark(id);try{history.replaceState(null,'','#'+id)}catch(x){}})});
    /* staggered entry */
    if(!reduce&&'IntersectionObserver' in window){var io2=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io2.unobserve(e.target)}})},{rootMargin:'0px 0px -8% 0px'});cards.forEach(function(c,k){c.style.animationDelay=((k%3)*60)+'ms';io2.observe(c)})}
    /* Kevin's card: its stage grows to end level with the card beside it in the row */
    function level(){[].forEach.call(root.querySelectorAll('.wbx-shop__kc'),function(k){var st=k.querySelector('.wbx-shop__kc-stage');if(!st)return;st.style.height='';if(window.innerWidth<750)return;var p=k.previousElementSibling;if(!p||Math.abs(p.offsetTop-k.offsetTop)>4)return;var d=p.offsetHeight-k.offsetHeight;if(d!==0&&d>-90&&d<200)st.style.height=Math.max(330,st.offsetHeight+d)+'px'})}
    level();window.addEventListener('resize',level);window.addEventListener('load',level);if(document.fonts&&document.fonts.ready)document.fonts.ready.then(level);
    applyBand();
  }
  function all(){[].forEach.call(document.querySelectorAll('.wbx-shop'),init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all);else all();
  document.addEventListener('shopify:section:load',function(e){var r=e.target.querySelector('.wbx-shop');if(r)init(r)});
})();

  } catch(e) { console.error(e); }
})();
})();
